import React from 'react';
import styled from '@emotion/styled';
import { TextField } from '@mui/material';

import RangePicker from '../RangePicker';
import DateRangePicker from './FilterFormComponents/DateRangePicker';
import SwitchComponent from './FilterFormComponents/Switch';
import RangeSlider from './FilterFormComponents/RangeSlider';
import BooleanOptions from './FilterFormComponents/BooleanOptions';
import AutocompleteMulti from './FilterFormComponents/AutocompleteMulti';

const FormContainer = styled.div`
  margin-top: 1.5rem;
  /* display: flex;
  flex-direction: column;
  gap: 2rem; */
`;

const DateForm = ({ field }) => {
  return (
    <FormContainer>
      <DateRangePicker id={field} />
    </FormContainer>
  );
};

const NumberForm = ({ field }) => {
  return (
    <FormContainer>
      <RangeSlider id={field} />
    </FormContainer>
  );
};

const BalanceForm = ({ field }) => {
  return (
    <FormContainer>
      <SwitchComponent field={field} subfield="$gt" val={0} label="Open Balance"  />
      <RangeSlider id={field} />
    </FormContainer>
  );
};

const BooleanForm = ({ field }) => {
  return (
    <FormContainer>
      <BooleanOptions id={field} />
    </FormContainer>
  );
};

const AutoCompleteMulti = (props) => {
  return (
    <FormContainer>
      <AutocompleteMulti {...props} />
    </FormContainer>
  );
};


const SelectForm = ({type, id, url, values, fieldOptions, prefetch, additionalCollections}) => {
  let form;
  switch (type) {
    case 'date': 
      form = <DateForm field={id} />;
      break;
    case 'number': 
      form = <NumberForm field={id} />;
      break;
    case 'balance': 
      form = <BalanceForm field={id} />;
      break;
    case 'boolean': 
      form = <BooleanForm field={id} />;
      break;
    case 'autoMulti': 
      form = <AutoCompleteMulti field={id} values={values} fieldOptions={fieldOptions} prefetch={prefetch} url={url} additionalCollections={additionalCollections} />;
      break;
    default:
      form = <div>Default Form</div>;
  }
  return form;
}

export default SelectForm;

